<template>
    <div class="doctor-details-container" v-if="doctorInfo">
        <div class="doctor-wrapper">
            <div class="doctor-header-wrapper">
                <div class="doctor-head">
                    <van-image
                        round
                        width="1.6rem"
                        height="1.6rem"
                        fit="cover"
                        lazy-load
                        class="head-image"
                        :src="doctorInfo.headImgUrl"
                    />
                    <div class="doctor-info">
                        <div>
                            <span class="name">
                                {{ doctorInfo.doctorName }}
                                <span class="title">{{
                                    doctorInfo.title
                                }}</span>
                                <span class="title">{{
                                    doctorInfo.departmentName
                                }}</span>
                            </span>
                        </div>
                        <div class="organ">{{ doctorInfo.organName }}</div>
                        <div class="tags">
                            <span
                                class="hyd-tag"
                                v-for="(item, index) in doctorInfo.tagList"
                                :key="index"
                                >{{ item }}</span
                            >
                        </div>
                    </div>
                </div>
                <div class="doctor-tools">
                    <div>
                        好评率
                        <span>{{ doctorInfo.rate || 0 }}%</span>
                    </div>
                    <div>
                        接诊人数
                        <span>{{ doctorInfo.medicalTotal || 0 }}</span>
                    </div>
                </div>
            </div>
            <div class="good-at-wrapper">
                <div class="good-at">
                    <i class="goodAt"></i>
                    <div class="content" :class="goodAtClosed ? 'closed' : ''">
                        <span class="title">擅长:</span>
                        {{ doctorInfo.skill }}
                    </div>
                </div>
                <div class="good-at">
                    <i class="introduce"></i>
                    <div class="content" :class="goodAtClosed ? 'closed' : ''">
                        <span class="title">简介:</span>
                        {{ doctorInfo.introduce }}
                    </div>
                </div>
                <div class="closed-btn" @click="switchGoodAt">
                    <van-icon
                        :name="goodAtClosed ? 'arrow-down' : 'arrow-up'"
                    />
                </div>
            </div>
        </div>
        <div class="medical-tools">
            <template v-for="(item, index) in doctorInfo.consultItemList">
                <div
                    class="tools-item"
                    :class="item.enabled ? 'enable' : ''"
                    :key="index"
                    @click="consultHandle(item)"
                >
                    <img
                        :src="
                            require(`@/assets/icon/medical_${
                                item.enabled ? 1 : 2
                            }_${item.type}.png`)
                        "
                    />
                    <div class="title">{{ item.name }}</div>
                    <div class="deputy-title">
                        {{ item.enabled ? `${item.fee}/次` : "暂未开通" }}
                    </div>
                </div>
            </template>
        </div>
        <div class="medical-evaluation">
            <div class="medical-header">
                <div class="info">
                    <span class="title-left"></span>
                    <span class="title">患者评价</span>
                    <span class="title-deputy"
                        >({{ doctorInfo.evaluationTotal }})</span
                    >
                </div>
                <div class="more">
                    <span>全部评价</span>
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="medical-list">
                <div
                    class="medical-item"
                    v-for="(item, index) in doctorInfo.medicalEvaluationList"
                    :key="index"
                >
                    <div class="evaluation-info">
                        <span class="name">{{ item.nickname }}</span>
                        <van-rate
                            v-model="item.point"
                            readonly
                            allow-half
                            size="0.4rem"
                            color="var(--yellow)"
                            void-icon="star"
                            void-color="var(--bg)"
                        />
                    </div>
                    <div class="evaluation-content">{{ item.content }}</div>
                    <div class="evaluation-footr">
                        <span>{{ item.medicalTypeName }}</span>
                        <span>{{ item.evaluationDate }}</span>
                    </div>
                    <div class="border-bottom"></div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import officialApi from '@/api/officialApi';

export default {
    data() {
        return {
            doctorInfo: null,
            goodAtClosed: true,
            value: 1
        }
    },
    created() {
        const { schedId } = this;
        officialApi.getMedicalDoctor(schedId).then(res => {
            this.doctorInfo = res.data;
        }).catch(() => {

        });
    },
    methods: {
        switchGoodAt() {
            this.goodAtClosed = !this.goodAtClosed;
        },
        consultHandle(item) {
            const { doctorInfo, $toast, $router } = this;
            if (!item.enabled) {
                $toast('该功能暂未开通');
                return;
            }

            if (1 === item.type || 2 === item.type || 3 === item.type) {
                $router.push({
                    path: '/medical/inquiry_sheet',
                    query: {
                        schedId: doctorInfo.schedId
                    }
                });
            }
        }
    },
    props: {
        schedId: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="less" scoped  src="./index.less" />
